import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id: 'catalogos',
        title: 'Cotizador',
        translate: 'NAV.CATALOGOS',
        type: 'collapsable',
        icon: 'apps',
        children: [
            {
                id: 'cotizador',
                title: 'Cotizador',
                translate: 'NAV.COTIZADOR.TITLE',
                type: 'item',
                icon: 'create',
                url: '/cotizador/cotizador'
            },
            
        ]
    },
   
];
